module.exports = __webpack_public_path__ + "static/img/wear02.1dbaf28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wear02.png
// module id = 5A/U
// module chunks = 1